import React, {useContext} from 'react'
import {
  imagenAtenciones,
  imagenAtencionesGris,
  imagenRecargarCuentaHabilitado,
  imagenRecargarCuentaDeshabilitado,
  imagenVerMovimientosHabilitado,
  imagenVerMovimientosDeshabilitado,
  imagenOrdenes,
  imagenOrdenesGris,
  CrearYGestionarOrdenesHabilitado,
  CrearYGestionarOrdenesDeshabilitado,
  DescargaMasivaHabilitado,
  DescargaMasivaDeshabilitado,
} from '../../imagenes/imagenesMenu/Index'
import {
  imagenHome,
  BotonAgregar,
  BotonAgregarGris,
  imagenCerrar,
  imagenHomeGris,
  imagenCerrarGris,
  CendiatraLogo,
} from '../../imagenes'
import ImagenEstandar from '../ImagenEstandar'
import ImagenFondo from '../ImagenFondo'

import {ContextoAplicacion} from '../../contexto'
import {TEXTO_VISUAL, RUTAS_APLICACION} from '../../constantes'
import {
  ROLES,
  TIPOS_FACTURACION_PERMITIDOS,
  normalizarValorPermiso,
  useAutorizacion,
} from '../../autorizacion'

import MenuDinamico from './MenuDinamico'

import {useFeatureIsOn} from '@growthbook/growthbook-react'
import {TEXTO_FEATURE_FLAGS} from '../../constantes/featureFlags.js'

const ROLES_PORTAL = [ROLES.ADMINISTRATIVO, ROLES.MEDICO, ROLES.SALUD]
const ROLES_ADMINISTRATIVOS = [ROLES.ADMINISTRATIVO, ROLES.SALUD]

const BarraDeNavegacion = ({cerrarSesion}) => {
  const contexto = useContext(ContextoAplicacion)
  const {rol, tipoFacturacion} = useAutorizacion()
  const rolNormalizado = normalizarValorPermiso(rol)
  const facturacionNormalizada = normalizarValorPermiso(tipoFacturacion)

  const habilitarDescargaMasiva = useFeatureIsOn(
    TEXTO_FEATURE_FLAGS.DESCARGA_MASIVA
  )

  const featureFlagDescargaMasiva = habilitarDescargaMasiva
    ? {
        imagen: DescargaMasivaHabilitado,
        imagenDeshabilitado: DescargaMasivaDeshabilitado,
        texto: TEXTO_VISUAL.HOME.NAVEGACION.DESCARGA_MASIVA,
        ruta: RUTAS_APLICACION.DESCARGA_MASIVA,
        rolesVisibles: ROLES_ADMINISTRATIVOS,
        facturacionesVisibles: [
          TIPOS_FACTURACION_PERMITIDOS.CONTADO,
          TIPOS_FACTURACION_PERMITIDOS.CREDITO,
        ],
      }
    : null

  const arrayMenus = [
    {
      imagen: imagenHome,
      imagenDeshabilitado: imagenHomeGris,
      texto: TEXTO_VISUAL.HOME.NAVEGACION.INICIO,
      ruta: RUTAS_APLICACION.HOME,
      rolesVisibles: ROLES_PORTAL,
    },
    {
      imagen: imagenOrdenes,
      imagenDeshabilitado: imagenOrdenesGris,
      texto: TEXTO_VISUAL.HOME.NAVEGACION.GESTION_DE_ORDENES,
      ruta: RUTAS_APLICACION.ORDENES,
      rolesVisibles: ROLES_PORTAL,
      facturacionesVisibles: [TIPOS_FACTURACION_PERMITIDOS.CREDITO],
    },
    {
      imagen: imagenOrdenes,
      imagenDeshabilitado: imagenOrdenesGris,
      texto: TEXTO_VISUAL.HOME.NAVEGACION.GESTION_DE_ORDENES,
      ruta: RUTAS_APLICACION.ORDENES,
      rolesVisibles: [ROLES.MEDICO],
      facturacionesVisibles: [TIPOS_FACTURACION_PERMITIDOS.CONTADO],
    },
    {
      imagen: CrearYGestionarOrdenesHabilitado,
      imagenDeshabilitado: CrearYGestionarOrdenesDeshabilitado,
      texto: TEXTO_VISUAL.HOME.NAVEGACION.CREAR_GESTIONAR_ORDENES,
      ruta: RUTAS_APLICACION.ORDENES,
      rolesVisibles: ROLES_ADMINISTRATIVOS,
      facturacionesVisibles: [TIPOS_FACTURACION_PERMITIDOS.CONTADO],
      subMenus: [
        {
          titulo: TEXTO_VISUAL.HOME.NAVEGACION.CREAR_ORDEN,
          ruta: RUTAS_APLICACION.CREAR_ORDEN,
        },
        {
          titulo: TEXTO_VISUAL.HOME.NAVEGACION.GESTIONAR_ORDENES,
          ruta: RUTAS_APLICACION.ORDENES,
        },
      ],
    },
    {
      imagen: imagenAtenciones,
      imagenDeshabilitado: imagenAtencionesGris,
      texto: TEXTO_VISUAL.HOME.NAVEGACION.GESTION_ATENCIONES,
      ruta: RUTAS_APLICACION.GESTION_ATENCIONES,
      rolesVisibles: ROLES_PORTAL,
    },
    {
      imagen: imagenRecargarCuentaHabilitado,
      imagenDeshabilitado: imagenRecargarCuentaDeshabilitado,
      texto: TEXTO_VISUAL.HOME.NAVEGACION.REALIZAR_PAGOS,
      ruta: '/',
      rolesVisibles: ROLES_ADMINISTRATIVOS,
      facturacionesVisibles: [TIPOS_FACTURACION_PERMITIDOS.CONTADO],
      subMenus: [
        {
          titulo: TEXTO_VISUAL.HOME.NAVEGACION.RECARGAR_CUENTA,
          ruta: RUTAS_APLICACION.RECARGAR_SALDO,
        },
        {
          titulo: TEXTO_VISUAL.HOME.NAVEGACION.PAGAR_OTROS_SERVICIOS,
          ruta: RUTAS_APLICACION.PAGAR_OTROS_SERVICIOS,
        },
      ],
    },
    {
      imagen: BotonAgregar,
      imagenDeshabilitado: BotonAgregarGris,
      texto: TEXTO_VISUAL.HOME.NAVEGACION.CREAR_ORDEN,
      ruta: RUTAS_APLICACION.CREAR_ORDEN,
      deshailitado: false,
      rolesVisibles: ROLES_ADMINISTRATIVOS,
      facturacionesVisibles: [TIPOS_FACTURACION_PERMITIDOS.CREDITO],
    },
    {
      imagen: imagenVerMovimientosHabilitado,
      imagenDeshabilitado: imagenVerMovimientosDeshabilitado,
      texto: TEXTO_VISUAL.HOME.NAVEGACION.VER_MOVIMIENTOS,
      ruta: RUTAS_APLICACION.VER_DETALLE_Y_MOVIMIENTO,
      rolesVisibles: ROLES_ADMINISTRATIVOS,
      facturacionesVisibles: [TIPOS_FACTURACION_PERMITIDOS.CONTADO],
    },
    ...(featureFlagDescargaMasiva ? [featureFlagDescargaMasiva] : []),
    {
      imagen: imagenCerrar,
      imagenDeshabilitado: imagenCerrarGris,
      texto: TEXTO_VISUAL.HOME.NAVEGACION.CERRAR_SESION,
      ruta: '',
      funcion: cerrarSesion,
      rolesVisibles: ROLES_PORTAL,
    },
  ]

  const obtenerDatosMenu = () =>
    arrayMenus.filter((elemento) => {
      const cumpleRol =
        !elemento.rolesVisibles ||
        elemento.rolesVisibles.includes(rolNormalizado)
      const cumpleFacturacion =
        !elemento.facturacionesVisibles ||
        elemento.facturacionesVisibles.includes(facturacionNormalizada)

      return cumpleRol && cumpleFacturacion
    })

  return (
    <div className=" w-full flex justify-between items-center relative bg-white py-2">
      <div className="w-3/12 flex justify-center items-center">
        <ImagenEstandar
          imagen={CendiatraLogo}
          texto={'logoCendiatra'}
          estilosPersonalizados={'w-52 ml-5'}
        />
      </div>
      <div className="flex justify-center items-center w-6/12">
        <MenuDinamico datos={obtenerDatosMenu()} />
      </div>
      <div className="w-3/12 flex justify-center items-center">
        <ImagenFondo url={contexto.infoEmpresa?.imagen} estilos={'w-52 mr-5'} />
      </div>
    </div>
  )
}

export default BarraDeNavegacion
